interface Props {
  topic: string | null;
  title: string;
  excerpt: string | null;
  publishedAt: string;
  updatedAt: string | null;
  readingMinutes: number;
  authorName: string;
}

function formatDate(iso: string) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

function initials(name: string) {
  return name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function BlogArticleHero({
  topic,
  title,
  excerpt,
  publishedAt,
  updatedAt,
  readingMinutes,
  authorName,
}: Props) {
  return (
    <header className="mb-10 pb-8 border-b border-border">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mb-5">
        {topic && (
          <span className="inline-flex items-center h-6 px-2.5 rounded-full bg-primary/10 text-primary text-caption font-semibold">
            {topic}
          </span>
        )}
        <time dateTime={publishedAt} className="text-caption text-muted-foreground tabular-nums">
          {formatDate(publishedAt)}
        </time>
        <span aria-hidden="true" className="text-muted-foreground/50">·</span>
        <span className="text-caption text-muted-foreground">{readingMinutes} min read</span>
      </div>
      <h1 className="text-h1 mb-5">
        {title}
      </h1>
      {excerpt && (
        <p className="text-lead text-muted-foreground mb-8">
          {excerpt}
        </p>
      )}
      <div className="flex items-center gap-3">
        <div
          aria-hidden="true"
          className="h-11 w-11 rounded-full bg-primary/10 text-primary ring-1 ring-primary/20 flex items-center justify-center text-body-sm font-semibold"
        >
          {initials(authorName)}
        </div>
        <div>
          <p className="text-body-sm font-medium text-foreground">{authorName}</p>
          {updatedAt && (
            <p className="text-caption text-muted-foreground">
              Updated {formatDate(updatedAt)}
            </p>
          )}
        </div>
      </div>
    </header>
  );
}